module.exports = __webpack_public_path__ + "img/drop-down-white.060958a8.svg";